<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.edit" | translate}} {{"admin.weee-system.weee-system" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendEditionRequest()" [formGroup]="weeeSystemEditForm" autocomplete="off">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.dialogs.description" |translate}}</mat-label>
          <input [formControl]="descriptionControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}}</mat-label>
          <mat-select [formControl]="countryControl">
            <mat-option *ngFor="let country of data.countries" [value]="country.id">{{country.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Charts Permission</mat-label>
          <mat-select [disabled]="true" [formControl]="chartPermissionControl">
            <mat-option value="NONE">No access to charts</mat-option>
            <mat-option value="ALL">Access to all charts</mat-option>
            <mat-option value="COLLECTED">Access to all charts except cost charts</mat-option>
          </mat-select>
        </mat-form-field>

<!--        <mat-form-field appearance="fill">-->
<!--          <mat-label>Intelligence Charts Permission</mat-label>-->
<!--          <mat-select [formControl]="intelligenceChartPermissionControl">-->
<!--            <mat-option [value]="false">No access to intelligence charts</mat-option>-->
<!--            <mat-option [value]="true">Access to all intelligence charts</mat-option>-->
<!--          </mat-select>-->
<!--        </mat-form-field>-->

        <mat-checkbox [formControl]="memberControl">{{"admin.weee-system.member" | translate}}</mat-checkbox>
        <mat-checkbox [disabled]="true" [formControl]="intelligenceChartPermissionControl">Access to intelligence charts</mat-checkbox>

        <h2>{{"admin.weee-system.users" |translate}}</h2>

        <div class="table-container">
          <table mat-table [dataSource]="users" matSort>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.name' |translate}}</th>
              <td mat-cell *matCellDef="let user">{{user.name}}</td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.first-name' |translate}}</th>
              <td mat-cell *matCellDef="let user">{{user.firstName}}</td>
            </ng-container>

            <ng-container matColumnDef="role.name">
              <th mat-header-cell *matHeaderCellDef>{{'admin.weee-system.role' |translate}}</th>
              <td mat-cell *matCellDef="let user">{{user.role?.name}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>

          <mat-paginator color="primary" [length]="totalElements"
                         [pageSize]="pageSize"
                         (page)="onPageChange($event)"
                         [pageSizeOptions]="pageSizes">
          </mat-paginator>
        </div>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="weeeSystemEditForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
